import React from 'react';
import SearchNavbar from '../components/SearchNavbar'

export default function Search() {
    return (
        <div>
            <SearchNavbar />
            <h2>We are on Search view</h2>
        </div>
    )
}
